import http from "../../shared/http"

const widgets = {
    state: {
        widgets: []
    },
    actions: {
        fetchWidgets({commit}) {
            return new Promise((resolve, reject) => {
                http.get("/v1/system/widget/list", {
                    headers: {
                        'X-Project-Uuid': localStorage.getItem("current_project_uuid")
                    }
                })
                .then((resp) => {
                    commit('SET_WIDGETS', resp.data || [])
                    resolve()
                }).catch((err) => {
                    reject(err)
                })
            })
        }
    },
    mutations: {
        SET_WIDGETS (state, widgets) {
            state.widgets = widgets
        },

        SET_WIDGET (state, widget) {
            state.widgets.push(widget)
        },

        DELETE_WIDGET (state, uuid) {
            state.widgets = state.widgets.filter(w => {
                return w.uuid != uuid
            })
        } 
    },
    getters: {
        widget: (state) => (uuid) => {
            return state.widgets.find((e) => {
                return e.uuid == uuid
            })

        },

        widgets(state) {
            return state.widgets
        }
    }
  }

export default widgets